import { useEffect, useState } from 'react';
import TableSearch from 'components/Table/TableSearch';
import FilterPills from 'components/Table/FilterPills';
import LoadingButton from '@enerex/unified-ui-react/LoadingButton';
import AddIcon from '@enerex/unified-ui-react/icons/AddIcon';
import Select from 'components/UnifiedSelect';

export const STATUS_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
];

const LookupToolbar = ({ definition, appliedSearch, onSearch, status, onStatusChange, showStatus = true, onAdd }) => {
    const [search, setSearch] = useState('');
    const [draftStatus, setDraftStatus] = useState(status);
    useEffect(() => { setDraftStatus(status); }, [status]);
    const applyFilters = (value = search) => {
        onSearch(showStatus ? value.trim() || appliedSearch || '' : value.trim());
        if (showStatus) onStatusChange(draftStatus);
        setSearch('');
    };
    return (
        <>
            <div className="settings-lookup__toolbar-actions justify-content-end mb-3">
                {showStatus && <LoadingButton type="button" variant="primary" onClick={() => applyFilters()}>Apply</LoadingButton>}
                <LoadingButton type="button" variant="primary" className="settings-lookup__add" onClick={onAdd} disabled={!onAdd} title={!onAdd ? "Adding records is not connected yet." : undefined}>
                    <AddIcon /> Add {definition.singularTitle}
                </LoadingButton>
            </div>
            <div className="settings-lookup__toolbar">
                <div className="settings-lookup__search" role="search">
                    <TableSearch value={search} onChange={setSearch} onSearch={applyFilters}
                        showAction={!showStatus} showApplied={false}
                        maxLength={200} label={`Search ${definition.title.toLowerCase()}`} />
                </div>
                <div className="settings-lookup__toolbar-filters">
                {showStatus && <div className="settings-lookup__status-filter">
                    <label className="settings-lookup__label" htmlFor={`lookup-status-${definition.id}`}>Active</label>
                    <Select
                        inputId={`lookup-status-${definition.id}`}
                        options={STATUS_OPTIONS}
                        value={draftStatus}
                        onChange={setDraftStatus}
                        isSearchable={false}
                        isClearable={false}
                    />
                </div>}
                </div>
            </div>
            <FilterPills filters={[
                { label: 'Search', value: appliedSearch, onRemove: () => onSearch('') },
                { label: 'Status', value: showStatus && status.value !== 'all' ? status.label : '',
                    onRemove: () => { setDraftStatus(STATUS_OPTIONS[0]); onStatusChange(STATUS_OPTIONS[0]); } },
            ]} />
        </>
    );
};

export default LookupToolbar;
